import Vue from 'vue'
import App from './App'

import VueI18n from 'vue-i18n'
import router from './router'
import store from './store'
import lodash from 'lodash'
import ElementUI from 'element-ui'
import echarts from 'echarts'
import CKEditor from 'ckeditor4-vue'
import enLocale from 'element-ui/lib/locale/lang/en'
import zhLocale from 'element-ui/lib/locale/lang/zh-CN'
import Meta from "vue-meta";
import directive from './directive'

import 'element-ui/lib/theme-chalk/index.css'
import '@/assets/theme/index.css'
import '@/assets/icon/iconfont.css'
import 'animate.css/animate.min.css'
import '@/assets/css/common.css'  //公共样式类
import {formatTime} from "./utils/time";
import {changeTime} from "./utils/msgTime";
// import '@/assets/style/elementui.scss' //自定义element主题

Vue.config.productionTip = false

Vue.config.mytest = 'abc'

Vue.use( CKEditor );

Vue.use(VueI18n)

Vue.prototype.$echarts = echarts

Vue.use(Meta);

Vue.use(directive)

// 添加事件总线
Vue.prototype.$eventBus = new Vue();


// 分页组件
import Pagination from "@/components/Pagination";
Vue.component('Pagination', Pagination)

// 导入共用组件
import global from '@/common/constant/constant.vue'
Vue.prototype.COMMON = global

import VueGtag from 'vue-gtag'
Vue.use(VueGtag, {
  config: { id: "G-Z4YMT1QMPC" }
}, router);

import '@/assets/icons/index.js' // icon

// lodash是一个一致性、模块化、高性能的 JavaScript 实用工具库
Object.defineProperty(Vue.prototype, '$_', {value: lodash})

Vue.directive('title', function (el, binding) {
  document.title = el.dataset.title
})

// 格式化时间
Vue.filter('format', formatTime)
Vue.filter('changeTime', changeTime)


//转换时间
Vue.filter('replaceTime', function(date) {
  var json_date = new Date(date).toJSON();
  return new Date(new Date(json_date) + 8 * 3600 * 1000).toISOString().replace(/T/g, ' ').replace(/\.[\d]{3}Z/, '')
  })




const i18n = new VueI18n({
  // locale: 'en',
  locale: localStorage.getItem('lang') || 'en', // 从本地获取语言, 有则使用, 无则使用浏览器默认
  messages: {
    'zh': Object.assign(require('./common/lang/zh'),zhLocale),   // 中文语言包
    'en': Object.assign(require('./common/lang/en'),enLocale)    // 英文语言包
  },
  silentTranslationWarn: true
})

Vue.use(ElementUI,{
  i18n:(key,value) =>i18n.t(key,value)
})

window.vm = new Vue({
  el: '#app',
  i18n,
  router,
  store,
  template: '<App/>',
  components: {App}
})
Vue.config.silent = true;
window.eventBus = new Vue();



// WEBPACK FOOTER //
// ./src/main.js